import React from 'react';
import { withRouter } from 'react-router-dom';
//Components
import Home from '../Home/Home';
import Services from '../Services/Services';
import Team from '../Team/Team';
import About from '../About/About';
import Contact from '../Contact/Contact';
import QuoteForm from '../QuoteForm/QuoteForm';
//Tools
import { Switch, Route, Redirect } from 'react-router-dom';



const Main = () => {
    
    return (
        <>
            <Switch>
                <Route path='/home' component={Home} />
                <Route path='/services' component={Services} />
                <Route path='/team' component={Team} />
                <Route path='/about' component={About} />
                <Route exact path='/contact' component={Contact} />
                <Route path='/quote' component={QuoteForm} />
                <Redirect to='/home' />
            </Switch>
        </>
    )
}

export default withRouter(Main);